import React from "react";
import { FormattedMessage } from "react-intl";
import StyledLink from "../../../shared/StyledLink/StyledLink";
import "./digital.scss";
const Digital = () => {
  return (
    <div className="home-digital">
      <div className="circle"></div>
      <h1 className="big-title">
        <FormattedMessage
          id="DT"
          defaultMessage="Digital transformation"
        />
      </h1>
      <p className="def-text">
        <FormattedMessage
          id="Let"
          defaultMessage="Let us help you. We produce digital experiences, engaging content and impactful design solutions. We carefully define strategic concepts to deliver digital products that exceeds expectations. "
        />
      </p>
      <StyledLink
        to="/"
        styles="styled"
        linkName={
          <FormattedMessage
            id="Talk"
            defaultMessage="Let's Talk"
          />
        }
      />
    </div>
  );
};

export default Digital;
